<template>
    <div class="pa-2">
        
        <div class="row"> 
            <div class="col-xs-12 col-sm-3">
                <v-btn tile outlined color="orange" @click="subir">subir .excel</v-btn>
            </div>
        </div>
        <div class="row"> 
            <div class="col-xs-12 col-sm-3">
                <v-btn tile outlined color="blue" @click="subir2">subir .excel V2</v-btn>
            </div>
        </div>
        <v-divider class="mt-2" />

        <div>
            <v-tabs v-model="tab" @change="tab_cmabiado">
            <v-container fluid style="height: 100vh;">
                <v-tab>Migracion Academico</v-tab>
            </v-container>
            
            
            </v-tabs>

            <v-tabs-items v-model="tab">
                <v-tab-item>
                    <Migracion ref="refMigracionAcademico" />
                </v-tab-item>                
            </v-tabs-items>
        </div> 

        <Subircsv ref="refSubircsv" color="orange" :upload-url="urlAcademico"  title="Subir Migración Académico"  v-on:cargado="buscar" />
        <Subircsv ref="refSubircsv2" color="blue" :upload-url="urlAcademico2"  title="Subir Migración Académico V2" v-on:cargado="buscar" />
    </div>
</template>

<script>
//import {meses} from './utils.js'
import Subircsv from './subir_csv.vue'
import Migracion from './migracion.vue' 


export default {
    components:{ Subircsv,Migracion },
    data: () => ({
        meses:null, 
        loading: false,
        gestiones: [],
        nits:[], 
        tab: null,
        urlAcademico: process.env.VUE_APP_API_REST + "/api/v1/esam/migracion_academico",
        urlAcademico2: process.env.VUE_APP_API_REST + "/api/v1/esam/migracion_academico2",
        input: {
            mes: null,
            gestion: null,
            nit: {},
        }
    }),
    methods:{
        buildUrl(path) {
    const base = process.env.VUE_APP_API_REST || '';
    return base + path;
  },
        
        buscar(){
            this.tab_cmabiado(this.tab);
            
        },
        async tab_cmabiado(e){ 
            if(!this.isvalido()){
                return
            } 

            await new Promise(resolve => setTimeout(resolve, 350));

            if(e==0 && this.$refs.refMigracionAcademico){
                this.$refs.refMigracionAcademico.get_datos('sin',this.input.mes,this.input.gestion,this.input.nit)
            }
        },
        isvalido(){
          
            return true;
        },
        subir(){
            if(!this.isvalido()){
                return
            } 
            this.$refs.refSubircsv.openmodal(this.input, this.meses,this.gestiones);
        },
        subir2(){
            if(!this.isvalido()){
                return
            } 
            this.$refs.refSubircsv2.openmodal(this.input, this.meses,this.gestiones);
        }
    },
    mounted(){
        this.get_gestiones()
    }
}

</script>
